export default {
  features: 'content_allowed_values_field_t_wine_prod_features',
  tasting: 'content_allowed_values_field_t_wine_prod_tasting_label',
  winemaking: 'content_allowed_values_field_t_wine_prod_making_label',
  technote: 'content_allowed_values_field_t_wine_prod_tech_label',
  product_labels: 'wine_product_labels',
  shop_labels: 'shop_product_labels'
}
